import SunIcon from '@/assets/ui/theme/sun.svg';
import MoonIcon from '@/assets/ui/theme/moon.svg';

export { SunIcon, MoonIcon };
